import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import htmlParse from 'react-html-parser';
import AppContext from '../../../contexts/AppContext';
import './ModalTutorial.css';

class ModalTutorial extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open !== prevProps.open) {
      this.setState({
        open: this.props.open,
      });
    }
  }

  render() {
    const { dictionnary } = this.context;
    const { onCloseHandler } = this.props;
    const { open } = this.state;

    return (
      <>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className="modal"
          open={open}
          onClose={() => {
            if (onCloseHandler) {
              onCloseHandler();
            }
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          disableEnforceFocus
          disableAutoFocus
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className="paper">
              <h2 id="transition-modal-title">Create your Street Gallery </h2>
              <p id="transition-modal-description">
                {htmlParse(dictionnary.get('modal-tutorial'))}
              </p>
              <video className="video" autoPlay loop>
                <source
                  src="street-gallery-bts/assets/tutorial.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <br />
              <button
                type="button"
                id="start-creating-button"
                className="main-button main-button--inverted"
                onClick={() => {
                  if (onCloseHandler) {
                    onCloseHandler();
                  }
                }}
              >
                {dictionnary.get('common-start-creating')}
              </button>
            </div>
          </Fade>
        </Modal>
      </>
    );
  }
}

export default ModalTutorial;
